import React from 'react';
import { PickingBatchListTemplate } from 'themes/modules/picking-batch/pages';
import { PickingBatchListViewStore } from 'modules/picking-batch/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new PickingBatchListViewStore(rootStore), 'pickingBatchListViewStore')
class PickingBatchList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<PickingBatchListTemplate
				{...this.props}
				change={this.props.pickingBatchListViewStore.change}
				actions={this.props.pickingBatchListViewStore}
				showActions={this.props.pickingBatchListViewStore.showActions}
				viewStore={this.props.pickingBatchListViewStore}
			/>
		);
	}
}

export default PickingBatchList;



// WEBPACK FOOTER //
// ./src/modules/picking-batch/pages/PickingBatchList.jsx